/* Pen+Pillar: shows the customer's personalized case picture in the cart drawer
   and cart page. The picture is saved in this browser at add-to-cart by
   pp-personalize.js, keyed by variant and the personalization fields. */
(function () {
  var timer;

  function thumbs() {
    try { return JSON.parse(localStorage.getItem('pp-pz-thumbs') || '{}'); } catch (e) { return {}; }
  }

  function keyFor(item) {
    var p = item.properties || {};
    var names = Object.keys(p).filter(function (k) { return k.charAt(0) !== '_' && p[k]; }).sort();
    if (!names.length) return null;
    return item.variant_id + '|' + names.map(function (k) { return k + '=' + p[k]; }).join('|');
  }

  function apply() {
    var rows = document.querySelectorAll('[data-line-key]');
    if (!rows.length) return;
    var saved = thumbs();
    if (!Object.keys(saved).length) return;
    var needs = Array.prototype.some.call(rows, function (r) { return !r.hasAttribute('data-pp-pz'); });
    if (!needs) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var byKey = {};
      c.items.forEach(function (it) { byKey[it.key] = it; });
      rows.forEach(function (row) {
        row.setAttribute('data-pp-pz', '');
        var it = byKey[row.getAttribute('data-line-key')];
        var k = it && keyFor(it);
        var t = k && saved[k];
        var img = row.querySelector('img');
        if (!t || !img) return;
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = t.src;
      });
    }).catch(function () {});
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(apply, 60); }

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();
